<template>
  <q-form @submit="this.onSubmit" class="form">
    <div class="form__item">
      <CustomSelect :options="workGroupDictOptions" label="Группа работ" optionValueKey="work_group_dict_id"
        optionLabelKey="work_group_name" :required="true" placeholder="Выберите группу работ"
        :value="formData.work_group_dict_id || ''" @change="(value, row) => onChange('work_group_dict_id', value, row)"
        style="width: 100%;" :loading="workGroupDictOptionsLoading" />
    </div>
    <div class="form__item">
      <CustomSelect :options="employeesOptions" label="Прораб" optionValueKey="employee_id" optionLabelKey="fio"
        :required="true" placeholder="Выберите прораба" :value="formData.employee_id || ''"
        @change="(value, row) => onChange('employee_id', value, row)" style="width: 100%;"
        :loading="employeesLoading" />
    </div>
    <div class="form__item">
      <CustomDate label="Дата начала" :value="formData.date_start" @change_date="value => onChange('date_start', value)"
        required style="width: 100%;" />
    </div>
    <div class="form__item">
      <CustomDate label="Дата окончания" :value="formData.date_end" @change_date="value => onChange('date_end', value)"
        required style="width: 100%;" :disabled="!formData.date_start" :minDate="formData.date_start"
        :default-value="defaultValueEndDate" />
    </div>
    <CustomModalFooter :btn-loading="this.loading" />
  </q-form>
</template>
<script>

import CustomSelect from "@/components/form/CustomSelect";
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import CustomDate from "@/components/form/CustomDate";
import { getWorkGroupDict, getEmployees } from "@/views/TierBlocks/services";

export default {
  name: "add-tier-group-work",
  components: { CustomSelect, CustomModalFooter, CustomDate },
  props: ['data'],
  data() {
    return {
      loading: false,
      workGroupDictOptions: [],
      employeesOptions: [],
      employeesLoading: false,
      workGroupDictOptionsLoading: false,
      formData: {
        work_group_id: this.data?.body?.work_group_id || null,
        block_id: this.data?.body?.block_id || '',
        work_group_dict_id: this.data?.body?.work_group_dict_id || '',
        employee_id: this.data?.body?.employee_id || '',
        date_start: this.data?.body?.date_start || '',
        date_end: this.data?.body?.date_end || '',
      }
    }
  },
  methods: {
    onChange(key, value) {
      this.formData[key] = value
      
      // Если изменилась дата начала и дата окончания уже установлена
      if (key === 'date_start' && this.formData.date_end && value) {
        // Преобразуем строки формата DD.MM.YYYY в объекты Date
        const startParts = value.split('.');
        const endParts = this.formData.date_end.split('.');
        
        if (startParts.length === 3 && endParts.length === 3) {
          const startDate = new Date(startParts[2], startParts[1] - 1, startParts[0]);
          const endDate = new Date(endParts[2], endParts[1] - 1, endParts[0]);
          
          // Если дата окончания раньше новой даты начала, очищаем её
          if (endDate < startDate) {
            this.formData.date_end = '';
          }
        }
      }
    },
    async getWorkGroupDictOptions() {
      this.workGroupDictOptionsLoading = true
      const res = await getWorkGroupDict();
      this.workGroupDictOptionsLoading = false
      if (!res) return
      this.workGroupDictOptions = res;
    },
    async getEmployeesOptions() {
      this.employeesLoading = true
      const res = await getEmployees();
      this.employeesLoading = false
      if (!res) return
      this.employeesOptions = res;
    },
    async onSubmit() {
      this.loading = true
      await this.data?.onSubmit(this.formData)
      this.loading = false
    },
  },
  computed: {
    defaultValueEndDate() {
      const start_ = this.formData.date_start
      if (!start_ || start_.length < 10) return undefined
      const parts_ = start_.split('.')
      if (parts_.length !== 3) return undefined
      const d_ = new Date(parseInt(parts_[2], 10), parseInt(parts_[1], 10) - 1, parseInt(parts_[0], 10))
      d_.setDate(d_.getDate() + 1)
      const day_ = String(d_.getDate()).padStart(2, '0')
      const month_ = String(d_.getMonth() + 1).padStart(2, '0')
      return `${day_}.${month_}.${d_.getFullYear()}`
    }
  },
  mounted() {
    this.getWorkGroupDictOptions()
    this.getEmployeesOptions()
  }
}
</script>

<style scoped lang="scss">
.form {
  display: flex;
  flex-direction: column;
  width: 400px;
  gap: 15px;

  &__item {
    width: 100%;
    display: flex;
    gap: 16px;

    :deep(.custom-date) {
      width: 100%;
      max-width: 100%;
    }
  }

  @media (max-width: 460px) {
    width: 100%;
  }
}
</style>
